import React from 'react';
import { Building } from 'lucide-react';

const AssetManagerPage = () => {
  return (
    <div className="max-w-4xl mx-auto text-center py-20">
      <div className="mb-8">
        <div className="inline-flex items-center justify-center w-24 h-24 bg-amber-100 rounded-2xl mb-6">
          <Building size={48} className="text-amber-600" />
        </div>
      </div>

      <h1 className="text-5xl font-bold text-gray-900 mb-4">Asset Manager</h1>
      <p className="text-xl text-gray-600 mb-10 max-w-md mx-auto">
        Track, manage, and maintain company assets efficiently.
      </p>

      <div className="bg-white rounded-3xl shadow-xl p-10 max-w-lg mx-auto">
        <h2 className="text-2xl font-semibold mb-6 text-gray-800">Coming Soon</h2>
        <p className="text-gray-500 mb-8">
          Asset inventory, assignment tracking, maintenance schedules, and depreciation reports are being built.
        </p>
        <div className="text-sm text-gray-400">Expected: Q4 2026</div>
      </div>
    </div>
  );
};

export default AssetManagerPage;